import React from 'react'
import { useState } from 'react'
import Modal from 'react-modal/lib/components/Modal'
import "./externalLink.scss";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

Modal.setAppElement('#___gatsby');

function ExternalLink({ href, children, className = '' }) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleProceedClick = (e) => {
    if (href) {
      (typeof window !== 'undefined') && window.open(href, "_blank")
    }
    setModalOpen(false)
  }
  return (
    <>
      <a className={className} href={href} onClick={(e) => { e.preventDefault(); setModalOpen(true) }}>{children}</a>
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        style={customStyles}
        contentLabel="text-popup-modal"
      >
        <div className="external-modal">
          <div className="close-icon">
            <button className='' onClick={() => setModalOpen(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20.894" height="20.893" viewBox="0 0 20.894 20.893">
                <g id="Group_1500" data-name="Group 1500" transform="translate(10.447 -6.204) rotate(45)">
                  <line id="Line_405" data-name="Line 405" y2="23.548" transform="translate(11.774 0)" fill="none" stroke="#d93f04" strokeLinecap="round" strokeWidth="3" />
                  <line id="Line_406" data-name="Line 406" x2="23.548" transform="translate(0 11.774)" fill="none" stroke="#d93f04" strokeLinecap="round" strokeWidth="3" />
                </g>
              </svg>
            </button>
          </div>
          <div className="external-modal__content">
            <h2 className='head'>You are leaving this website</h2>
            <p>You are about to leave biolinerx.com. The link will take you to a website that may be maintained by a third party, which is solely responsible for its content. BioLineRx provides this link as a service to its web visitors, and is not responsible for the privacy policy or terms of use of any third-party website.</p>
            <div className='btn-wrap'>
              <button className='btn btn-primary has-icon-right btn-close' onClick={() => setModalOpen(false)}>Close
                <svg xmlns="http://www.w3.org/2000/svg" id="Cross" width="11.047" height="11.047" viewBox="0 0 11.047 11.047">
                  <path id="Union_3" data-name="Union 3" d="M9.767,10.828,5.524,6.585,1.281,10.828A.75.75,0,0,1,.22,9.767L4.463,5.524.22,1.281A.75.75,0,0,1,1.281.22L5.524,4.463,9.767.22a.75.75,0,0,1,1.061,1.061L6.585,5.524l4.243,4.243a.75.75,0,0,1-1.061,1.061Z" fill="rgba(217,63,4,0.2)" />
                </svg>
              </button>
              <button className='btn btn-primary has-icon-right' onClick={handleProceedClick}>Continue
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" className="svg-inline--fa fa-arrow-right " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"></path></svg>
              </button>
            </div>
          </div>
        </div>
      </Modal>

    </>
  )
}

export default ExternalLink